import type { Catalog } from "../../en";

/** Filipino: platform admin Usage & AI costs screen (mirrors en). */
export const usage: Catalog["adminScreens"]["usage"] = {
  title: "Usage at gastos sa AI",
  subtitle: "Magkano ang bawat mensahe sa LLM, embeddings at reranking. USD sa presyo ng provider, PHP sa {{fx}} bawat USD.",
  range: {
    label: "Saklaw ng petsa",
    mtd: "Ngayong buwan",
    d7: "Huling 7 araw",
    d30: "Huling 30 araw",
    d90: "Huling 90 araw",
    span: "{{from}} – {{to}}",
  },
  export: "I-export",
  exported: "Na-export ang usage bilang CSV",
  modelRouting: "Model routing",
  kpi: {
    messages: "Mga mensahe",
    messagesFoot: "{{conversations}} usapan · {{perConv}} mensahe/usapan",
    tokens: "Tokens in / out",
    tokensFoot: "avg {{in}} in · {{out}} out bawat mensahe",
    embedding: "Embedding tokens",
    embeddingFoot: "{{ingest}} ingestion · {{query}} query",
    rerank: "Rerank calls",
    rerankFoot: "{{cost}} gastos sa rerank",
    llmCost: "Gastos sa LLM",
    llmCostFoot: "≈ {{php}} · embeddings {{embed}}",
    perConversation: "Gastos bawat usapan",
    perConversationFoot: "Gastos sa AI {{php}} sa saklaw",
    cache: "Semantic cache hit rate",
    cacheFoot: "{{hits}} hit · natipid {{saved}}",
    margin: "Gross margin (AI)",
    marginFoot: "batay sa kita sa saklaw",
  },
  providers: {
    title: "Gastos bawat provider kada araw",
    subtitle: "USD · {{range}}",
    chart: "Gastos sa AI kada araw ayon sa provider",
    share: "{{share}} bahagi",
    emptyTitle: "Walang gastos sa AI sa saklaw na ito",
    emptyBody: "Lalabas dito ang gastos sa sandaling sumagot ang mga agent ng tenant.",
  },
  models: {
    title: "Ayon sa model",
    manage: "Pamahalaan ang mga provider",
    colModel: "Model",
    colProvider: "Provider",
    colRequests: "Requests",
    colTokensIn: "Tokens in",
    colTokensOut: "Tokens out",
    colP50: "p50",
    colP95: "p95",
    colCost: "Gastos",
    colShare: "Bahagi",
    seconds: "{{value}} s",
    emptyTitle: "Walang traffic sa model sa saklaw na ito",
    emptyBody: "Lalabas ang requests bawat model kapag nagsimulang sumagot ang mga agent.",
  },
  tenants: {
    title: "Mga tenant na may pinakamalaking gastos sa AI",
    subtitle: "{{range}} · kita = subscription + add-on",
    negativeOnly: "Negatibong margin lang",
    colTenant: "Tenant",
    colCost: "Gastos sa AI",
    colRevenue: "Kita",
    colMargin: "Margin",
    negative: "Negatibo",
    reviewOverrides: "Suriin ang overrides",
    emptyTitle: "Walang tumugmang tenant",
    emptyNegative: "Walang tenant na negatibo ang margin. Ayos!",
    emptyBody: "Lalabas dito ang mga tenant kapag may gastos na sila sa AI.",
    showAll: "Ipakita lahat ng tenant",
  },
  budget: {
    title: "Mga alerto sa budget",
    enabled: "Naka-on ang alerto sa budget",
    spend: "Gastos ngayong buwan",
    spendValue: "{{spend}} / {{budget}}",
    used: "{{pct}} nagamit ngayong buwan",
    threshold: "Alerto sa {{pct}}",
    monthly: "Buwanang budget (USD)",
    monthlyHint: "≈ {{php}} bawat buwan",
    alertAt: "Alerto sa",
    notify: "Abisuhan",
    notifyHint: "Mga email na pinaghihiwalay ng kuwit (hanggang 20).",
    notifyInvalid: "Maglagay ng tamang email na pinaghihiwalay ng kuwit.",
    amountInvalid: "Maglagay ng halaga mula 0 hanggang 10,000,000.",
    autoRoute: "Ilipat ang mga Starter tenant sa pinakamurang chat model kapag umabot sa 100% ang budget",
    save: "I-save ang budget",
    saved: "Na-save ang budget",
  },
  ingestion: {
    title: "Dami ng embeddings at ingestion",
    queue: "Status ng queue",
    embedIngest: "Embedding tokens (ingestion)",
    embedQuery: "Embedding tokens (query)",
    embedCost: "Gastos sa embedding",
    rerankCost: "Gastos sa rerank",
    note: "Hindi pa iniuulat ng usage API ang dami ng file, page at OCR.",
  },
};
